import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { MoreInfoIcon } from '@estee/elc-icons';
import { classes } from '~utils/ClassNames';
import { useTranslation } from '~sharedComponents/Providers/Translations/TranslationsHook';
import {
    SubscribeWrapper,
    StyledSubscribeLabel,
    StyledCheckbox
} from './ReplenishmentSubscribeStyles';
import { ReplenishmentTooltipModalContext } from '~views/ShoppingBagTab/CartSidebarItems/CartItem/ReplenishmentComponent/ReplenishmentTooltipModalContext/ReplenishmentTooltipModalContext';

const styledSubscribeLabelClass = classes('cart-auto-replenishment-subscribe-label');
const styledSubscribeCheckboxClass = classes('cart-auto-replenishment-subscribe-checkbox');
const translationsList = ['subscribeAndSaveDiscountPlusFreeShipping'];

export const ReplenishmentSubscribe = observer(({ setSubscribe, isChecked, isDisabled }) => {
    const { openModal } = useContext(ReplenishmentTooltipModalContext);
    const { subscribeAndSaveDiscountPlusFreeShipping } = useTranslation(translationsList);

    const onSubscribeChange = (event: React.ChangeEvent<HTMLInputElement>) =>
        setSubscribe(event.target.checked);

    return (
        <SubscribeWrapper>
            <StyledSubscribeLabel className={styledSubscribeLabelClass}>
                <StyledCheckbox
                    className={styledSubscribeCheckboxClass}
                    type="checkbox"
                    onChange={onSubscribeChange}
                    checked={isChecked}
                    disabled={isDisabled}
                />
                {subscribeAndSaveDiscountPlusFreeShipping}
            </StyledSubscribeLabel>
            <button onClick={openModal}>
                <MoreInfoIcon />
            </button>
        </SubscribeWrapper>
    );
});
